'use strict';

const {distinctUntilChanged, filter} = require('rxjs');
const request = require('superagent');
const store = require('../util/store');
const {obj} = require('iblokz-data');

const port = ''; // process.env.PORT && process.env.PORT !== '80' ? `:${process.env.PORT}` : '';
const url = `//${location.host || process.env.SERVER_URL || 'localhost'}${port}`;

const forceLogout = () => state => {
	store.set('user', null);
	store.set('token', null);
	setTimeout(() => {
		window.location = '#/';
	});
	return obj.patch(state, 'auth', {user: null, token: null});
};

const login = data => request
	.post(`${url}/api/auth/authorize`)
	.send(data)
	.set('Accept', 'application/json')
	.then(res => res.body)
	.then(({msg, user, token}) =>
		(user)
			? (
				store.set('user', user),
				store.set('token', token),
				state => obj.patch(state, 'auth', {user, token})
			)
			: state => state
	);

const register = data => request
	.post(`${url}/api/auth/register`)
	.send(data)
	.set('Accept', 'application/json')
	.then(({status}) =>
		(status === 201)
			? login(data)
			: state => state
	);

const logout = token => request
	.delete(`${url}/api/auth/token`)
	.query({token})
	.set('Accept', 'application/json')
	.then(res => res.body)
	.then(data =>
		(data.success)
			? forceLogout()
			: state => state
	);

const actions = {
	forceLogout,
	login,
	logout: forceLogout,
	register,
	initial: {user: store.get('user'), token: store.get('token')}
};

let unhook = () => {};
const hook = ({state$, actions}) => {
	let subs = [];
	subs.push(
		state$.pipe(
			distinctUntilChanged((a, b) => a.auth.user === b.auth.user),
			filter(state => state.auth.user && state.auth.user.email)
		).subscribe(state => state.router.page === 'auth' && actions.router.go('home'))
	);

	unhook = () => {
		subs.forEach(sub => sub.unsubscribe());
		subs = [];
	};
};

module.exports = {
	actions,
	hook,
	unhook: () => unhook()
};
